var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShopping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 14.7463L6.77651 46.7408L6.96595 47H41.6635L41.8529 46.7408L45 14.683L44.6883 14.4238H37.7586C37.447 6.67175 31.5867 1 23.9664 1C16.3461 1 10.553 6.66543 10.2414 14.4238H3.31166L3 14.7463ZM11.1214 24.5217C10.9319 23.1559 11.433 21.3285 13.4496 21.3285H34.5443C36.5609 21.3285 37.1231 23.1559 36.9398 24.5217L35.3632 37.4206C35.1737 38.8559 35.0454 40.0953 32.9677 40.0953H15.1484C13.0707 40.0953 12.8813 38.8559 12.6918 37.3574L11.1152 24.5217H11.1214ZM17.2933 14.4238C17.6722 9.7321 20.5687 7.58227 24.0336 7.58227C27.4985 7.58227 30.395 9.7321 30.7739 14.4238H17.2995H17.2933Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShopping);
export default __webpack_public_path__ + "static/media/icon_shopping.23d30c2c4c866ed9c6a7094f0e67fde8.svg";
export { ForwardRef as ReactComponent };